import { inject, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ExoticsComponent } from './exotics/exotics.component';
import { AuthGuard } from './services/guards/auth.guard';
import { AdminGuard } from './services/guards/admin.guard';
import { SsoComponent } from './sso/sso.component';
import { AppWrapperComponent } from './app-wrapper/app-wrapper.component';
import { PerseusAdminGuard } from './services/guards/perseus-admin.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [() => inject(AuthGuard).canActivate()],
    component: AppWrapperComponent,
    children: [
      {
        path: '',
        component: ExoticsComponent,
        pathMatch: 'full'
      },
      {
        path: 'admin',
        canActivate: [() => inject(AdminGuard).canActivate()],
        loadChildren: () =>
          import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'perseus-admin',
        canActivate: [() => inject(PerseusAdminGuard).canActivate()],
        loadChildren: () =>
          import('./perseus-admin/perseus-admin.module').then(
            m => m.PerseusAdminModule
          )
      },
      {
        path: 'monitor',
        canActivate: [() => inject(AdminGuard).canActivate()],
        loadChildren: () =>
          import('./monitoring/monitoring.module').then(m => m.MonitoringModule)
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('./user-management/user-management.module').then(
            m => m.UserManagementModule
          )
      },
      {
        path: 'static-data-management',
        loadChildren: () =>
          import('./static-data-management/static-data-management.module').then(
            m => m.StaticDataManagementModule
          )
      },
      {
        path: 'white-label-trading-rules',
        loadChildren: () =>
          import(
            './white-label-trading-rules/white-label-trading-rules.module'
          ).then(m => m.WhiteLabelTradingRulesModule)
      }
    ]
  },
  {
    path: 'brand',
    loadChildren: () =>
      import('./branding/branding.module').then(m => m.BrandingModule)
  },
  { path: 'login', component: LoginComponent },
  { path: 'sso/:clientId', component: SsoComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
